if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
      }
      onVariantChangeUnsubscriber = undefined;
      connectedCallback() {
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleOptionValueChange.bind(this)
        );
        this.previousVariant = JSON.parse(
          this.querySelector("[data-selected-variant]").innerHTML
        );
      }
      disconnectedCallback() {
        if (this.onVariantChangeUnsubscriber) {
          this.onVariantChangeUnsubscriber();
        }
      }
      handleOptionValueChange = ({ data }) => {
        if (
          this.previousVariant.options[0] != data.variant.options[0] ||
          this.previousVariant.options[1] != data.variant.options[1]
        ) {
          const swiper = this.querySelector("media-gallery .swiper").swiper;
          swiper.wrapperEl.innerHTML = "";
          const documentFragment = document.createDocumentFragment();
          [
            ...data.html.querySelectorAll(
              "media-gallery .swiper-wrapper.main-swiper .swiper-slide"
            ),
          ].forEach((x) => documentFragment.appendChild(x));
          swiper.wrapperEl.appendChild(documentFragment);
          swiper.update();
        }
        this.previousVariant = data.variant;
      };
    }
  );
}
